import axios from 'axios';
import * as types from '@/store/types';

export default {
  saveToken({ commit }, token) {
    commit(types.SAVE_TOKEN, token);
  },
  async getPages({ commit }, params) {
    try {
      const { data } = await axios.get(`/api/web/pages/${params}`);
      commit(types.FETCH_PAGE, { page: data });
      return data;
    } catch (e) {
      return null;
    }
  }
};
